import React from 'react';
import { UseFormGetValues } from 'react-hook-form';
import { Button } from 'reactstrap';
import { LocationValue } from '../..';
import { LocationService } from '../../../../../../../../../services/v1/applicant_tracking/LocationService';
import { SelectOption } from '../../../../../../../../../components/Select';
import { AlertType } from '../../../../../../../../../components/Alert';

interface PropTypes {
  handleClose: () => void;
  getValues: UseFormGetValues<LocationValue>;
  setSelectedLocation: (selectedOption: SelectOption) => void;
  isValid: boolean;
  setAlertType: (alertType: AlertType) => void;
  setAlertMessage: (message: JSX.Element) => void;
}

export function ButtonsRow(props: PropTypes) {
  const createLocation = async () => {
    try {
      const location = await LocationService.create({
        name: props.getValues('locationName'),
        country: props.getValues('location.country'),
        address: props.getValues('location.address'),
        city: props.getValues('location.city'),
        state: props.getValues('location.state'),
      });

      props.setSelectedLocation({
        value: location.id.toString(),
        label: location.name,
      });

      props.setAlertType(AlertType.Success);
      props.setAlertMessage(
        <>
          <strong>{`'${location.name}'`}</strong> was created successfully
        </>,
      );

      props.handleClose();
    } catch (error) {
      props.setAlertType(AlertType.Danger);
      props.setAlertMessage(<>Location was not created successfully</>);
      props.handleClose();
    }
  };
  return (
    <div className='d-flex justify-content-end mt-4'>
      <Button
        className='me-2'
        color='danger'
        onClick={() => props.handleClose()}
      >
        Cancel
      </Button>
      <Button
        color='primary'
        type='submit'
        disabled={!props.isValid}
        onClick={() => createLocation()}
      >
        Create and Select Location
      </Button>
    </div>
  );
}
